/**
 * Hides quantity selector and remove button on Planet (smart-cart) addon items.
 * Addon items are identified by .smart-cart-line-properties containing "Producto base".
 * Loaded globally so it works on every page where Planet's cart drawer is present.
 */
(function () {
  if (window.__persoPlanetAddonCtrlBound) return;
  window.__persoPlanetAddonCtrlBound = true;

  function markAddonItems() {
    document.querySelectorAll('.smart-cart-line-properties').forEach(function (span) {
      if (span.textContent.indexOf('Producto base') === -1) return;
      var line = span.closest('.smart-cart-line');
      if (line && !line.dataset.persAddon) {
        line.dataset.persAddon = 'true';
      }
    });
  }

  var _addonObserver = new MutationObserver(markAddonItems);

  function attachAddonObserver() {
    var container = document.querySelector('.smart-cart-container, .smart-cart-modal-content');
    if (container && !container.__persAddonObserved) {
      container.__persAddonObserved = true;
      _addonObserver.observe(container, { childList: true, subtree: true });
      markAddonItems();
    }
  }

  attachAddonObserver();

  // Planet renders its cart lazily — watch body for when it mounts
  var _mountObserver = new MutationObserver(attachAddonObserver);
  _mountObserver.observe(document.body, { childList: true, subtree: true });
})();
